export const InvitationList = [
    {
        Name: "Rats",
        Level: "Canard",
        Episodes: [
            {
                ID: "2",
                Name: "Rats",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Pete",
                                BookID: "100003",
                                Deck: ["13", "13", "14", "15", "16",],
                            },
                            {
                                Name: "Lenny",
                                BookID: "100001",
                                Deck: ["11", "11", "14", "15", "16",],
                            },
                            {
                                Name: "Mang-chi",
                                BookID: "100002",
                                Deck: ["12", "12", "14", "15", "16",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Yun's Office",
        Level: "Canard",
        Episodes: [
            {
                ID: "3",
                Name: "Yun's Office Fixers",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Grade 9 Yun's Fixer",
                                BookID: "101003",
                                Deck: ["1", "2", "3", "1", "2", "3",],
                            },
                            {
                                Name: "Grade 9 Yun's Fixer",
                                BookID: "101003",
                                Deck: ["1", "2", "3", "1", "2", "3",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "4",
                Name: "Yun's Office Rookie",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Finn",
                                BookID: "100004",
                                Deck: ["102003", "102003", "102006", "102006", "100002", "100002", "100003", "100003",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "5",
                Name: "Yun's Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Yun's Fixer",
                                BookID: "101001",
                                Deck: ["102006", "102006", "100001", "100001", "100002", "100003", "100003", "100004",],
                            },
                            {
                                Name: "Yun's Fixer",
                                BookID: "101002",
                                Deck: ["102006", "102006", "100001", "100001", "100002", "100003", "100003", "100004",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Yun",
                                BookID: "100006",
                                Deck: ["102001", "102001", "102002", "102002", "100001", "100001", "102006", "102006",],
                            },
                            {
                                Name: "Eri",
                                BookID: "100005",
                                Deck: ["102004", "102004", "102005", "102005", "102006", "102006", "100002", "100003",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Brotherhood of Iron",
        Level: "Canard",
        Episodes: [
            {
                ID: "6",
                Name: "Brotherhood of Iron",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Mo",
                                BookID: "100007",
                                Deck: ["103001", "103001", "103004", "103004", "103004", "100001", "100001", "103006",],
                            },
                            {
                                Name: "Consta",
                                BookID: "100008",
                                Deck: ["103002", "103002", "103004", "103004", "103005", "100001", "100001", "100005",],
                            },
                            {
                                Name: "Arnold",
                                BookID: "100009",
                                Deck: ["103003", "103003", "103004", "103004", "103005", "103005", "103006", "103006",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Hook Office",
        Level: "Canard",
        Episodes: [
            {
                ID: "7",
                Name: "Hook Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Hook Fixer",
                                BookID: "111001",
                                Deck: ["104004", "104004", "104005", "104005", "104006", "104006", "100003", "100004",],
                            },
                            {
                                Name: "Hook Fixer",
                                BookID: "111001",
                                Deck: ["104004", "104004", "104005", "104005", "104006", "104006", "100003", "100004",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Taein",
                                BookID: "100011",
                                Deck: ["104002", "104004", "100004", "100005", "104006", "104006", "104005", "104005",],
                            },
                            {
                                Name: "McCullin",
                                BookID: "100010",
                                Deck: ["104001", "104004", "100004", "100005", "104006", "104006", "104005", "104005",],
                            },
                            {
                                Name: "Naoki",
                                BookID: "100012",
                                Deck: ["104003", "104004", "100004", "100005", "104006", "104006", "104005", "104005",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Pierre's Bistro",
        Level: "Urban Myth",
        Episodes: [
            {
                ID: "10001",
                Name: "Pierre's Bistro",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Pierre",
                                BookID: "110002",
                                Deck: ["201003", "201003", "201004", "201004", "201005", "201006", "201007", "201007",],
                            },
                            {
                                Name: "Jack",
                                BookID: "110001",
                                Deck: ["201001", "201001", "201002", "201005", "201005", "201006", "201007", "201007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Streetlight Office",
        Level: "Urban Myth",
        Episodes: [
            {
                ID: "10002",
                Name: "Streetlight Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "San",
                                BookID: "110005",
                                Deck: ["202005", "202005", "202006", "202006", "202007", "202008", "202009", "202009",],
                            },
                            {
                                Name: "Mars",
                                BookID: "110003",
                                Deck: ["202001", "202001", "202002", "202002", "202007", "202008", "202009", "202009",],
                            },
                            {
                                Name: "Lulu",
                                BookID: "110004",
                                Deck: ["202003", "202003", "202004", "202004", "202007", "202008", "202009", "202009",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "10003",
                Name: "Lulu of Streetlight",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Lulu's Friend",
                                BookID: "111005",
                                Deck: ["200001", "200001", "200002", "200003", "200004", "200004", "200005", "200005",],
                            },
                            {
                                Name: "Lulu's Friend",
                                BookID: "111006",
                                Deck: ["200001", "200001", "200002", "200003", "200004", "200004", "200005", "200005",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Lulu",
                                BookID: "110004",
                                Deck: ["202003", "202003", "202004", "202004", "202007", "202008", "202009", "202009",],
                            },
                            {
                                Name: "Lulu's Friend",
                                BookID: "111005",
                                Deck: ["200001", "200001", "200002", "200003", "200004", "200004", "200005", "200005",],
                            },
                            {
                                Name: "Lulu's Friend",
                                BookID: "111006",
                                Deck: ["200001", "200001", "200002", "200003", "200004", "200004", "200005", "200005",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Zwei Association South Section 6",
        Level: "Urban Legend",
        Episodes: [
            {
                ID: "20001",
                Name: "Zwei Crewmembers",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Zwei Crew",
                                BookID: "121004",
                                Deck: ["300001", "300001", "300002", "300003", "300003", "301009", "301009", "301010",],
                            },
                            {
                                Name: "Zwei Crew",
                                BookID: "121002",
                                Deck: ["300001", "300002", "300003", "300003", "301009", "301009", "300005", "300005",],
                            },
                            {
                                Name: "Zwei Crew",
                                BookID: "121004",
                                Deck: ["300001", "300001", "300002", "300003", "300003", "301009", "301009", "301010",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "20002",
                Name: "Zwei Association Ⅰ",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Zwei Crew",
                                BookID: "121004",
                                Deck: ["300001", "300001", "300002", "300003", "300003", "301009", "301009", "301010",],
                            },
                            {
                                Name: "Zwei Crew",
                                BookID: "121003",
                                Deck: ["301011", "301011", "300002", "300002", "300003", "300003", "300004", "300005",],
                            },
                            {
                                Name: "Zwei Crew",
                                BookID: "121004",
                                Deck: ["300001", "300001", "300002", "300003", "300003", "301009", "301009", "301010",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "San",
                                BookID: "120001",
                                Deck: ["301001", "301002", "301002", "301009", "301010", "301010", "301011", "301011",],
                            },
                            {
                                Name: "Julia",
                                BookID: "120002",
                                Deck: ["301003", "301003", "301004", "301009", "301010", "301010", "301011", "301011",],
                            },
                            {
                                Name: "Zwei Crew",
                                BookID: "121004",
                                Deck: ["300001", "300001", "300002", "300003", "300003", "301009", "301009", "301010",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "20003",
                Name: "Zwei Association Ⅱ",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Zwei Crew",
                                BookID: "121001",
                                Deck: ["300001", "300001", "300002", "300003", "300003", "300004", "300004", "301010",],
                            },
                            {
                                Name: "Zwei Crew",
                                BookID: "121004",
                                Deck: ["300001", "300001", "300002", "300003", "300003", "301009", "301009", "301010",],
                            },
                            {
                                Name: "Zwei Crew",
                                BookID: "121004",
                                Deck: ["300001", "300001", "300002", "300003", "300003", "301009", "301009", "301010",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Walter",
                                BookID: "120004",
                                Deck: ["301007", "301007", "301008", "301009", "301009", "301010", "301011", "301011",],
                            },
                            {
                                Name: "Isadora",
                                BookID: "120003",
                                Deck: ["301005", "301005", "301006", "301009", "301009", "301010", "301011", "301011",],
                            },
                            {
                                Name: "Zwei Crew",
                                BookID: "121004",
                                Deck: ["300001", "300001", "300002", "300003", "300003", "301009", "301009", "301010",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Molar Office",
        Level: "Urban Legend",
        Episodes: [
            {
                ID: "20004",
                Name: "Molar Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Olga",
                                BookID: "120006",
                                Deck: ["302002", "302002", "302002", "302004", "302004", "302007", "302007", "302007",],
                            },
                            {
                                Name: "Mika",
                                BookID: "120005",
                                Deck: ["302001", "302001", "302004", "302005", "302005", "302006", "302007", "302007",],
                            },
                            {
                                Name: "Rain",
                                BookID: "120007",
                                Deck: ["302003", "302003", "302004", "302005", "302006", "302006", "302007", "302007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Stray Dogs",
        Level: "Urban Legend",
        Episodes: [
            {
                ID: "20005",
                Name: "Stray Dogs",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Stray Dog",
                                BookID: "121005",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Stray Dog",
                                BookID: "121005",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Stray Dog",
                                BookID: "121005",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Gyeong-mi",
                                BookID: "120008",
                                Deck: ["303001", "303001", "303001", "303001", "303002", "303002", "303002", "303002",],
                            },
                            {
                                Name: "Dino",
                                BookID: "120009",
                                Deck: ["303003", "303003", "303004", "303007", "303008", "303008", "303009", "303009",],
                            },
                            {
                                Name: "Zulu",
                                BookID: "120010",
                                Deck: ["303005", "303005", "303006", "303006", "303007", "303008", "303009", "303009",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The Carnival",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "30001",
                Name: "The Carnival",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Alpha",
                                BookID: "130001",
                                Deck: ["401001", "401002", "401003", "401003", "401004", "401005", "401005", "401006", "401006",],
                            },
                            {
                                Name: "Beta",
                                BookID: "130002",
                                Deck: ["401001", "401006", "401006", "401002", "401002", "401005", "401005", "401006", "401006",],
                            },
                            {
                                Name: "Gamma",
                                BookID: "130003",
                                Deck: ["401001", "401003", "401003", "401003", "401003", "401005", "401005", "401006", "401006",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Full-Stop Office",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "30002",
                Name: "Full-Stop Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Liwei",
                                BookID: "130004",
                                Deck: ["402009", "402009", "402009", "402010", "402010", "402010", "402008", "402008", "402008",],
                            },
                            {
                                Name: "Stephan",
                                BookID: "130005",
                                Deck: ["402003", "402003", "402004", "402004", "402005", "402005", "402005", "402006", "402006",],
                            },
                            {
                                Name: "Tamaki",
                                BookID: "130006",
                                Deck: ["402001", "402001", "402002", "402002", "402006", "402006", "402007", "402007", "402007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Dawn Office",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "30003",
                Name: "Dawn Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Salvador",
                                BookID: "130007",
                                Deck: ["403001", "403001", "403002", "403002", "403002", "403005", "403006", "403006", "403006",],
                            },
                            {
                                Name: "Yuna",
                                BookID: "130008",
                                Deck: ["403003", "403003", "403003", "403004", "403004", "403004", "403006", "403006", "403006",],
                            },
                            {
                                Name: "Philip",
                                BookID: "130009",
                                Deck: ["403005", "403005", "403005", "403006", "403006", "403006", "403007", "403007", "403007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Gaze Office",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "30004",
                Name: "Gaze Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Alloc",
                                BookID: "130010",
                                Deck: ["404001", "404001", "404001", "404002", "404002", "404002", "404007", "404007", "404008",],
                            },
                            {
                                Name: "Dalloc",
                                BookID: "130011",
                                Deck: ["404005", "404006", "404006", "404006", "404007", "404007", "404008", "404008", "404008",],
                            },
                            {
                                Name: "Bono",
                                BookID: "130012",
                                Deck: ["404003", "404004", "404007", "404008",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Love Town",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "30005",
                Name: "Love Town",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Love Townsperson",
                                BookID: "130013",
                                Deck: ["405003", "405003", "405003", "405003", "405003", "405003", "405006", "405006",],
                            },
                            {
                                Name: "Love Townsperson",
                                BookID: "130015",
                                Deck: ["405005", "405005", "405005", "405005", "405005", "405005", "405008", "405008",],
                            },
                            {
                                Name: "Love Townsperson",
                                BookID: "130014",
                                Deck: ["405004", "405004", "405004", "405004", "405004", "405004", "405007", "405007",],
                            },
                            {
                                Name: "Love Townsperson",
                                BookID: "130015",
                                Deck: ["405005", "405005", "405005", "405005", "405005", "405005", "405008", "405008",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Tomerry",
                                BookID: "130016",
                                Deck: ["405001", "405002", "405009", "405010", "405011", "405012", "405013",],
                            },
                            {
                                Name: "Love Townsperson",
                                BookID: "130013",
                                Deck: ["405003", "405003", "405003", "405003", "405003", "405003", "405006", "405006",],
                            },
                            {
                                Name: "Love Townsperson",
                                BookID: "130014",
                                Deck: ["405004", "405004", "405004", "405004", "405004", "405004", "405007", "405007",],
                            },
                            {
                                Name: "Love Townsperson",
                                BookID: "130015",
                                Deck: ["405005", "405005", "405005", "405005", "405005", "405005", "405008", "405008",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Kurokumo Clan",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "30006",
                Name: "Kurokumo Clan",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Kurokumo Henchman",
                                BookID: "131001",
                                Deck: ["406007", "406007", "406007", "406008", "406008", "406008", "406009", "406009", "406009",],
                            },
                            {
                                Name: "Kurokumo Henchman",
                                BookID: "131001",
                                Deck: ["406007", "406007", "406007", "406008", "406008", "406008", "406009", "406009", "406009",],
                            },
                            {
                                Name: "Kurokumo Henchman",
                                BookID: "131001",
                                Deck: ["406007", "406007", "406007", "406008", "406008", "406008", "406009", "406009", "406009",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Sayo",
                                BookID: "130018",
                                Deck: ["406001", "406002", "406002", "406002", "406007", "406007", "406008", "406008", "406008",],
                            },
                            {
                                Name: "Yang",
                                BookID: "130019",
                                Deck: ["406003", "406003", "406004", "406004", "406004", "406004", "406004", "406008", "406008",],
                            },
                            {
                                Name: "Gin",
                                BookID: "130020",
                                Deck: ["406005", "406005", "406006", "406006", "406006", "406006", "406008", "406008", "406008",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Musicians of Bremen",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "30007",
                Name: "Musicians of Bremen",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Meow",
                                BookID: "130021",
                                Deck: ["407002", "407002", "407002", "407005", "407005", "407005", "407006", "407007", "407007",],
                            },
                            {
                                Name: "MuMu",
                                BookID: "130022",
                                Deck: ["407001", "407001", "407001", "407004", "407004", "407004", "407007", "407007", "407007",],
                            },
                            {
                                Name: "Oink",
                                BookID: "130023",
                                Deck: ["407003", "407003", "407003", "407006", "407006", "407006", "407007", "407007", "407007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Wedge Office",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "30008",
                Name: "Wedge Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Oscar",
                                BookID: "130024",
                                Deck: ["408001", "408001", "408002", "408002", "408002", "408005", "408005", "408005", "408005",],
                            },
                            {
                                Name: "Pameli",
                                BookID: "130025",
                                Deck: ["408003", "408003", "408003", "408004", "408004", "408004", "408005", "408005", "408005",],
                            },
                            {
                                Name: "Pamela",
                                BookID: "130026",
                                Deck: ["408003", "408003", "408003", "408004", "408004", "408004", "408005", "408005", "408005",],
                            },
                            {
                                Name: "Philip",
                                BookID: "130027",
                                Deck: ["403005", "403005", "403005", "403005", "403007", /*"408006", "408006", "408006",*/],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Philip",
                                BookID: "130028",
                                Deck: [],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Shi Association South Section 2",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "40001",
                Name: "Shi Association",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Shi S. Section 2 Fixer",
                                BookID: "141001",
                                Deck: ["501005", "501005", "501005", "501005", "501005", "501006", "501006", "501006", "501007",],
                            },
                            {
                                Name: "Shi S. Section 2 Fixer",
                                BookID: "141001",
                                Deck: ["501005", "501005", "501005", "501005", "501005", "501006", "501006", "501006", "501007",],
                            },
                            {
                                Name: "Shi S. Section 2 Fixer",
                                BookID: "141001",
                                Deck: ["501005", "501005", "501005", "501005", "501005", "501006", "501006", "501006", "501007",],
                            },
                            {
                                Name: "Shi S. Section 2 Fixer",
                                BookID: "141001",
                                Deck: ["501005", "501005", "501005", "501005", "501005", "501006", "501006", "501006", "501007",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Yujin",
                                BookID: "140001",
                                Deck: ["501001", "501005", "501006", "501007", "501007",],
                            },
                            {
                                Name: "Valentin",
                                BookID: "140002",
                                Deck: ["501002", "501002", "501002", "501005", "501005", "501007", "501007", "501007",],
                            },
                            {
                                Name: "Tenma",
                                BookID: "140003",
                                Deck: ["501003", "501003", "501003", "501004", "501004", "501004", "501005", "501005", "501007",],
                            },
                            {
                                Name: "Shi S. Section 2 Fixer",
                                BookID: "141001",
                                Deck: ["501005", "501005", "501005", "501005", "501005", "501006", "501006", "501006", "501007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Puppets",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "40002",
                Name: "Puppets",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Puppet",
                                BookID: "140007",
                                Deck: ["502005", "502005", "502005", "502005", "502006", "502006", "502006", "502006",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "140006",
                                Deck: ["502005", "502005", "502005", "502005", "502006", "502006", "502006", "502006",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "140006",
                                Deck: ["502005", "502005", "502005", "502005", "502006", "502006", "502006", "502006",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "140007",
                                Deck: ["502005", "502005", "502005", "502005", "502006", "502006", "502006", "502006",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "140006",
                                Deck: ["502005", "502005", "502005", "502005", "502006", "502006", "502006", "502006",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Nimble Puppet",
                                BookID: "140004",
                                Deck: ["502001", "502001", "502002", "502005", "502005", "502006", "502006",],
                            },
                            {
                                Name: "Nimble Puppet",
                                BookID: "140004",
                                Deck: ["502001", "502001", "502002", "502005", "502005", "502006", "502006",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "140006",
                                Deck: ["502005", "502005", "502005", "502005", "502006", "502006", "502006", "502006",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "140007",
                                Deck: ["502005", "502005", "502005", "502005", "502006", "502006", "502006", "502006",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "140006",
                                Deck: ["502005", "502005", "502005", "502005", "502006", "502006", "502006", "502006",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Weighty Puppet",
                                BookID: "140005",
                                Deck: ["502003", "502004", "502007", "502007", "502007",],
                            },
                            {
                                Name: "Nimble Puppet",
                                BookID: "140004",
                                Deck: ["502001", "502001", "502002", "502005", "502005", "502006", "502006",],
                            },
                            {
                                Name: "Nimble Puppet",
                                BookID: "140004",
                                Deck: ["502001", "502001", "502002", "502005", "502005", "502006", "502006",],
                            },
                            {
                                Name: "Nimble Puppet",
                                BookID: "140004",
                                Deck: ["502001", "502001", "502002", "502005", "502005", "502006", "502006",],
                            },
                            {
                                Name: "Nimble Puppet",
                                BookID: "140004",
                                Deck: ["502001", "502001", "502002", "502005", "502005", "502006", "502006",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The 8 o'Clock Circus",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "40003",
                Name: "The 8 o'Clock Circus",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Emma & Noah",
                                BookID: "140008",
                                Deck: ["503001", "503002", "503003", "503008",],
                            },
                            {
                                Name: "Lion",
                                BookID: "140011",
                                Deck: ["503005", "503005", "503005", "503005", "503005", "503005",],
                            },
                            {
                                Name: "Monkey",
                                BookID: "140012",
                                Deck: ["503006", "503006", "503006", "503006", "503006", "503006",],
                            },
                            {
                                Name: "Elephant",
                                BookID: "140013",
                                Deck: ["503007", "503007", "503007", "503007", "503007", "503007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Sweepers",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "40004",
                Name: "Sweepers",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Anton",
                                BookID: "140015",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504003", "504005", "504005",],
                            },
                            {
                                Name: "Lyla",
                                BookID: "140016",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504004", "504004", "504005", "504005",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Sweeper",
                                BookID: "141002",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504003", "504005", "504005", "504006", "504006",],
                            },
                            {
                                Name: "Valerie",
                                BookID: "140017",
                                Deck: ["504001", "504001", "504001", "504002", "504002", "504005", "504006", "504005", "504006",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Index Proselytes",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "40005",
                Name: "Index Proselytes",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Index Proselyte",
                                BookID: "140018",
                                Deck: ["505001", "505002", "505003", "505004", "505005", "505006", "505007",],
                            },
                            {
                                Name: "Index Proselyte",
                                BookID: "140018",
                                Deck: ["505001", "505002", "505003", "505004", "505005", "505006", "505007",],
                            },
                            {
                                Name: "Index Proselyte",
                                BookID: "140018",
                                Deck: ["505001", "505002", "505003", "505004", "505005", "505006", "505007",],
                            },
                            {
                                Name: "Index Proselyte",
                                BookID: "140018",
                                Deck: ["505001", "505002", "505003", "505004", "505005", "505006", "505007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "WARP Cleanup Crew",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "40006",
                Name: "WARP Cleanup Crew",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "WARP Cleanup Agent",
                                BookID: "140022",
                                Deck: ["506002", "506003", "506003", "506004", "506004", "506005", "506005", "506007", "506007",],
                            },
                            {
                                Name: "WARP Cleanup Agent",
                                BookID: "140022",
                                Deck: ["506002", "506003", "506003", "506004", "506004", "506005", "506005", "506007", "506007",],
                            },
                            {
                                Name: "WARP Cleanup Agent",
                                BookID: "140022",
                                Deck: ["506002", "506003", "506003", "506004", "506004", "506005", "506005", "506007", "506007",],
                            },
                            {
                                Name: "WARP Cleanup Agent",
                                BookID: "140022",
                                Deck: ["506002", "506003", "506003", "506004", "506004", "506005", "506005", "506007", "506007",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Rose",
                                BookID: "140019",
                                Deck: ["506001", "506002", "506003", "506003", "506004", "506005", "506006", "506007", "506007",],
                            },
                            {
                                Name: "Sen",
                                BookID: "140020",
                                Deck: ["506001", "506002", "506002", "506003", "506004", "506004", "506006", "506007",],
                            },
                            {
                                Name: "Lesti",
                                BookID: "140021",
                                Deck: ["506001", "506002", "506002", "506003", "506003", "506004", "506005", "506005", "506007",],
                            },
                            {
                                Name: "WARP Cleanup Agent",
                                BookID: "140022",
                                Deck: ["506002", "506003", "506003", "506004", "506004", "506005", "506005", "506007", "506007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Smiling Faces",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "40007",
                Name: "Smiling Faces",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Smiling Face",
                                BookID: "140026",
                                Deck: ["507001", "507002", "507003", "507004", "507005", "507005", "507006", "507006", "507007",],
                            },
                            {
                                Name: "Smiling Face",
                                BookID: "140026",
                                Deck: ["507001", "507002", "507003", "507004", "507005", "507005", "507006", "507006", "507007",],
                            },
                            {
                                Name: "Smiling Face",
                                BookID: "140026",
                                Deck: ["507001", "507002", "507003", "507004", "507005", "507005", "507006", "507006", "507007",],
                            },
                            {
                                Name: "Smiling Face",
                                BookID: "140026",
                                Deck: ["507001", "507002", "507003", "507004", "507005", "507005", "507006", "507006", "507007",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Wang",
                                BookID: "140023",
                                Deck: ["507001", "507002", "507003", "507003", "507004", "507005", "507006", "507006", "507007",],
                            },
                            {
                                Name: "Jin",
                                BookID: "140024",
                                Deck: ["507001", "507002", "507003", "507003", "507005", "507005", "507006", "507006", "507007",],
                            },
                            {
                                Name: "Mi",
                                BookID: "140025",
                                Deck: ["507001", "507002", "507003", "507003", "507005", "507005", "507006", "507006", "507007",],
                            },
                            {
                                Name: "Smiling Face",
                                BookID: "140026",
                                Deck: ["507001", "507002", "507003", "507004", "507005", "507005", "507006", "507006", "507007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The Crying Children",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "40008",
                Name: "The Crying Children",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Unseeing Child",
                                BookID: "142002",
                                Deck: ["508006", "508006", "508006", "508006",],
                            },
                            {
                                Name: "Unhearing Child",
                                BookID: "142003",
                                Deck: ["508006", "508006", "508006", "508006",],
                            },
                            {
                                Name: "Unspeaking Child",
                                BookID: "142004",
                                Deck: ["508006", "508006", "508006", "508006",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Liu Association South Section 2",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50001",
                Name: "Liu Association Section 2",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "50002",
                Name: "Liu Association Section 2 Ⅱ",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Lowell",
                                BookID: "150002",
                                Deck: ["601001", "601001", "601008", "601003", "601003", "601007", "601007", "601013", "601013",],
                            },
                            {
                                Name: "Cecil",
                                BookID: "150003",
                                Deck: ["601001", "601009", "601002", "601007", "601007", "601010", "601010", "601012", "601013", "601013",],
                            },
                            {
                                Name: "Mei",
                                BookID: "150004",
                                Deck: ["601001", "601009", "601002", "601007", "601007", "601011", "601011", "601013", "601013",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 2 Fixer",
                                BookID: "150001",
                                Deck: ["601001", "601002", "601003", "601004", "601005", "601006", "601007", "601007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The Thumb",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50003",
                Name: "The Thumb",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Thumb Soldato",
                                BookID: "150005",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150005",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150005",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150005",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Thumb Soldato",
                                BookID: "150005",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150005",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150005",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150005",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "50004",
                Name: "The Thumb Ⅱ",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Denis",
                                BookID: "150009",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602009", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150105",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150105",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150105",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Boris",
                                BookID: "150007",
                                Deck: ["602007", "602007", "602008", "602008", "602010", "602010", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150105",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150105",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150105",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Kalo",
                                BookID: "150006",
                                Deck: ["602001", "602002", "602003", "602004", "602009", "602011", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150105",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Katriel",
                                BookID: "150008",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602009", "602012", "602012", "602012",],
                            },
                            {
                                Name: "Thumb Soldato",
                                BookID: "150105",
                                Deck: ["602001", "602002", "602003", "602004", "602006", "602012", "602012", "602012",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Cane Office",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50005",
                Name: "Cane Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Nemo",
                                BookID: "150010",
                                Deck: ["603001", "603001", "603001", "603003", "603005", "603005", "603007", "603007",],
                            },
                            {
                                Name: "Martina",
                                BookID: "150011",
                                Deck: ["603006", "603006", "603006", "603007", "603007", "603008", "603008", "603008",],
                            },
                            {
                                Name: "Bada",
                                BookID: "150012",
                                Deck: ["603002", "603004", "603004", "603006", "603007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Argalia & The Churches of Gear",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50006",
                Name: "The Blue Reverberation",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Argalia",
                                BookID: "150013",
                                Deck: [],
                            },
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Index Proxies",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50007",
                Name: "Index Proxies",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Index Proselyte",
                                BookID: "151001",
                                Deck: ["505001", "505003", "505004", "605006", "605007",],
                            },
                            {
                                Name: "Index Proselyte",
                                BookID: "151001",
                                Deck: ["505001", "505003", "505004", "605006", "605007",],
                            },
                            {
                                Name: "Index Proselyte",
                                BookID: "151001",
                                Deck: ["505001", "505003", "505004", "605006", "605007",],
                            },
                            {
                                Name: "Index Proselyte",
                                BookID: "151001",
                                Deck: ["505001", "505003", "505004", "605006", "605007",],
                            },
                            {
                                Name: "Index Proselyte",
                                BookID: "151001",
                                Deck: ["505001", "505003", "505004", "605006", "605007",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Esther",
                                BookID: "150015",
                                Deck: ["605002", "605004", "605005", "605006", "605007", "605008", "605021", "605022",],
                            },
                            {
                                Name: "Hubert",
                                BookID: "150016",
                                Deck: ["605003", "605004", "605005", "605006", "605007", "605008", "605021",],
                            },
                            {
                                Name: "Gloria",
                                BookID: "150017",
                                Deck: ["605001", "605004", "605005", "605006", "605007", "605008",],
                            },
                            {
                                Name: "Index Proselyte",
                                BookID: "151002",
                                Deck: ["505001", "505003", "505004", "605006", "605007",],
                            },
                            {
                                Name: "Index Proselyte",
                                BookID: "151002",
                                Deck: ["505001", "505003", "505004", "605006", "605007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Liu Association South Section 1",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50008",
                Name: "Liu Association Section 1",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Liu S. Section 1 Fixer",
                                BookID: "150019",
                                Deck: ["601001", "601007", "606006", "606006", "606006", "606007", "606007", "606007",],
                            },
                            {
                                Name: "Liu S. Section 1 Fixer",
                                BookID: "150019",
                                Deck: ["601001", "601007", "606006", "606006", "606006", "606007", "606007", "606007",],
                            },
                            {
                                Name: "Liu S. Section 1 Fixer",
                                BookID: "150019",
                                Deck: ["601001", "601007", "606006", "606006", "606006", "606007", "606007", "606007",],
                            },
                            {
                                Name: "Liu S. Section 1 Fixer",
                                BookID: "150019",
                                Deck: ["601001", "601007", "606006", "606006", "606006", "606007", "606007", "606007",],
                            },
                            {
                                Name: "Liu S. Section 1 Fixer",
                                BookID: "150019",
                                Deck: ["601001", "601007", "606006", "606006", "606006", "606007", "606007", "606007",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Xiao",
                                BookID: "150020",
                                Deck: ["601001", "601001", "606001", "606003", "606004", "606005", "601007", "601007", "601007",],
                            },
                            {
                                Name: "Miris",
                                BookID: "150021",
                                Deck: ["601001", "606002", "606003", "606004", "606006", "606006", "606006", "601007", "601007",],
                            },
                            {
                                Name: "Chun",
                                BookID: "150018",
                                Deck: ["601001", "606002", "606002", "606004", "606004", "606005", "606005", "601007", "601007",],
                            },
                            {
                                Name: "Liu S. Section 1 Fixer",
                                BookID: "150019",
                                Deck: ["601001", "601007", "606006", "606006", "606006", "606007", "606007", "606007",],
                            },
                            {
                                Name: "Liu S. Section 1 Fixer",
                                BookID: "150019",
                                Deck: ["601001", "601007", "606006", "606006", "606006", "606007", "606007", "606007",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The Red Mist",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50009",
                Name: "The Red Mist",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Kali",
                                BookID: "150022",
                                Deck: ["607001", "607002", "607003", "607004", "607005", "607006",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "R Corp",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50010",
                Name: "R Corp",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Rudolph",
                                BookID: "150026",
                                Deck: ["608005", "608005", "608005", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Reindeer",
                                BookID: "150103",
                                Deck: ["608005", "608005", "608010", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Reindeer",
                                BookID: "150103",
                                Deck: ["608005", "608005", "608010", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Reindeer",
                                BookID: "150103",
                                Deck: ["608005", "608005", "608010", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Reindeer",
                                BookID: "150103",
                                Deck: ["608005", "608005", "608010", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Maxim",
                                BookID: "150025",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015", "608015",],
                            },
                            {
                                Name: "Rhino",
                                BookID: "150102",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Rhino",
                                BookID: "150102",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Rhino",
                                BookID: "150102",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Rhino",
                                BookID: "150102",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Nikolai",
                                BookID: "150023",
                                Deck: ["608009", "608009", "608009", "608013", "608013", "608013", "608014", "608014", "608014",],
                            },
                            {
                                Name: "Myo",
                                BookID: "150024",
                                Deck: ["608007", "608007", "608008", "608008", "608013", "608013", "608014", "608014", "608014",],
                            },
                            {
                                Name: "Rabbit",
                                BookID: "150101",
                                Deck: ["608007", "608007", "608007", "608008", "608013", "608013", "608014", "608014", "608014",],
                            },
                            {
                                Name: "Rabbit",
                                BookID: "150101",
                                Deck: ["608007", "608007", "608007", "608008", "608013", "608013", "608014", "608014", "608014",],
                            },
                            {
                                Name: "Rabbit",
                                BookID: "150101",
                                Deck: ["608007", "608007", "608007", "608008", "608013", "608013", "608014", "608014", "608014",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "R Corp II",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50011",
                Name: "R Corp II",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Rudolph",
                                BookID: "150030",
                                Deck: ["608005", "608005", "608010", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Reindeer",
                                BookID: "150103",
                                Deck: ["608005", "608005", "608010", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Reindeer",
                                BookID: "150103",
                                Deck: ["608005", "608005", "608010", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Reindeer",
                                BookID: "150103",
                                Deck: ["608005", "608005", "608010", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Reindeer",
                                BookID: "150103",
                                Deck: ["608005", "608005", "608010", "608010", "608010", "608014", "608014", "608014", "608015",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Maxim",
                                BookID: "150029",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015", "608015",],
                            },
                            {
                                Name: "Rhino",
                                BookID: "150102",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Rhino",
                                BookID: "150102",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Rhino",
                                BookID: "150102",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Rhino",
                                BookID: "150102",
                                Deck: ["608006", "608011", "608011", "608011", "608014", "608014", "608014", "608015",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Myo",
                                BookID: "150028",
                                Deck: ["608007", "608007", "608008", "608008", "608013", "608013", "608014", "608014", "608014",],
                            },
                            {
                                Name: "Rabbit",
                                BookID: "150101",
                                Deck: ["608007", "608007", "608007", "608008", "608013", "608013", "608014", "608014", "608014",],
                            },
                            {
                                Name: "Rabbit",
                                BookID: "150101",
                                Deck: ["608007", "608007", "608007", "608008", "608013", "608013", "608014", "608014", "608014",],
                            },
                            {
                                Name: "Rabbit",
                                BookID: "150101",
                                Deck: ["608007", "608007", "608007", "608008", "608013", "608013", "608014", "608014", "608014",],
                            },
                            {
                                Name: "Rabbit",
                                BookID: "150101",
                                Deck: ["608007", "608007", "608007", "608008", "608013", "608013", "608014", "608014", "608014",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Nikolai",
                                BookID: "150031",
                                Deck: ["608004", "608009", "608009", "608009", "608013", "608013", "608014", "608014", "608014",],
                            },
                            {
                                Name: "Myo",
                                BookID: "150032",
                                Deck: ["608001", "608013", "608013", "608013", "608013", "608014", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Maxim",
                                BookID: "150033",
                                Deck: ["608003", "608006", "608006", "608011", "608011", "608011", "608014", "608014", "608015",],
                            },
                            {
                                Name: "Rudolph",
                                BookID: "150034",
                                Deck: ["608002", "608005", "608010", "608014", "608014", "608014", "608015", "608015", "608015",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The Purple Tear",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50012",
                Name: "The Purple Tear",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Iori",
                                BookID: "150035",
                                Deck: [],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Xiao",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50013",
                Name: "Xiao",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Xiao",
                                BookID: "150036",
                                Deck: ["601001", "601002", "601007", "606001", "606003", "606004", "606006", "610010", "610011",],
                            },
                            {
                                Name: "Miris",
                                BookID: "150037",
                                Deck: ["601001", "601002", "606002", "606003", "606004", "606006", "610011",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Xiao",
                                BookID: "150038",
                                Deck: ["610002", "610003", "610005", "610006", "610008", "610009",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "얀샋ㄷ요무",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "50014",
                Name: "얀샋ㄷ요무",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "얀샋ㄷ요무",
                                BookID: "150051",
                                Deck: ["611001", "611031", "611032", "611033", "611034", "611035", "611036",],
                            },
                            {
                                Name: "Left Hand",
                                BookID: "150039",
                                Deck: ["611002", "611021", "611022", "611023",],
                            },
                            {
                                Name: "Right Hand",
                                BookID: "150040",
                                Deck: ["611003", "611021", "611022", "611023",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Hana Association",
        Level: "Impuritas Civitatis",
        Episodes: [
            {
                ID: "60001",
                Name: "Hana Association",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Hana S. Section 3 Fixer",
                                BookID: "160001",
                                Deck: ["701004", "701006", "701007", "701008", "701010", "701010", "701011", "701011", "701012",],
                            },
                            {
                                Name: "Hana S. Section 3 Fixer",
                                BookID: "160001",
                                Deck: ["701004", "701006", "701007", "701008", "701010", "701010", "701011", "701011", "701012",],
                            },
                            {
                                Name: "Hana S. Section 3 Fixer",
                                BookID: "160001",
                                Deck: ["701004", "701006", "701007", "701008", "701010", "701010", "701011", "701011", "701012",],
                            },
                            {
                                Name: "Hana S. Section 3 Fixer",
                                BookID: "160001",
                                Deck: ["701004", "701006", "701007", "701008", "701010", "701010", "701011", "701011", "701012",],
                            },
                            {
                                Name: "Hana S. Section 3 Fixer",
                                BookID: "160001",
                                Deck: ["701004", "701006", "701007", "701008", "701010", "701010", "701011", "701011", "701012",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Mirinae",
                                BookID: "160002",
                                Deck: ["701001", "701004", "701005", "701005", "701006", "701011", "701011", "701012",],
                            },
                            {
                                Name: "Harold",
                                BookID: "160003",
                                Deck: ["701001", "701004", "701008", "701008", "701008", "701011", "701011", "701012",],
                            },
                            {
                                Name: "Hana S. Section 3 Fixer",
                                BookID: "160101",
                                Deck: ["701004", "701006", "701007", "701008", "701010", "701010", "701011", "701011", "701012",],
                            },
                            {
                                Name: "Hana S. Section 3 Fixer",
                                BookID: "160101",
                                Deck: ["701004", "701006", "701007", "701008", "701010", "701010", "701011", "701011", "701012",],
                            },
                            {
                                Name: "Hana S. Section 3 Fixer",
                                BookID: "160101",
                                Deck: ["701004", "701006", "701007", "701008", "701010", "701010", "701011", "701011", "701012",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "60002",
                Name: "Olivier",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Olivier",
                                BookID: "160004",
                                Deck: ["701001", "701002", "701003", "701005", "701006", "701008", "701010", "701011", "701012",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The Reverberation Ensemble",
        Level: "Impuritas Civitatis",
        Episodes: [
            {
                ID: "70001",
                Name: "The Crying Children",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Philip",
                                BookID: "1301011",
                                Deck: ["703111", "703112", "703113", "703114", "703115", "703116", "703117", "703118",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "70002",
                Name: "The Church of Gears",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Eileen",
                                BookID: "1302011",
                                Deck: ["703201", "703202", "703203", "703201", "703202", "703203", "703201", "703202", "703203",],
                            },
                            {
                                Name: "Gear Worshipper",
                                BookID: "1302021",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Gear Worshipper",
                                BookID: "1302021",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Gear Worshipper",
                                BookID: "1302021",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Gear Worshipper",
                                BookID: "1302021",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "70003",
                Name: "The Eighth Chef",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Greta",
                                BookID: "1303011",
                                Deck: ["703312", "703313", "703314", "703315", "703316", "703317", "703318", "703319", "703310",],
                            },
                            {
                                Name: "Fresh Meat",
                                BookID: "1303021",
                                Deck: [],
                            },
                            {
                                Name: "Fresh Meat",
                                BookID: "1303021",
                                Deck: [],
                            },
                            {
                                Name: "Fresh Meat",
                                BookID: "1303021",
                                Deck: [],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "70004",
                Name: "The Musicians of Bremen",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "The Musicians of Bremen",
                                BookID: "1304011",
                                Deck: ["703411", "703412", "703413", "703414", "703415", "703416",],
                            },
                            {
                                Name: "Ms. Mermaid",
                                BookID: "1304031",
                                Deck: ["703521", "703521", "703526", "703526", "703522", "703523", "703525",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "1304021",
                                Deck: ["703710", "703710", "703710", "703711", "703711", "703711", "703712", "703712",],
                            },
                            {
                                Name: "Church of Gears Worshipper",
                                BookID: "150014",
                                Deck: ["604001", "604001", "604002", "604003", "604003", "604004", "604004", "604005", "604005",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "1304021",
                                Deck: ["703710", "703710", "703710", "703711", "703711", "703711", "703712", "703712",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "70005",
                Name: "The 8 o'Clock Circus",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Oswald",
                                BookID: "1305011",
                                Deck: ["703501", "703502", "703503", "703504", "703505", "703506", "703507",],
                            },
                            {
                                Name: "Mr. Knife",
                                BookID: "1305021",
                                Deck: ["703511", "703512", "703513", "703514",],
                            },
                            {
                                Name: "Ms. Mermaid",
                                BookID: "1305031",
                                Deck: ["703521", "703522", "703523", "703524", "703525",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "70006",
                Name: "L'heure du Loup",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Tanya",
                                BookID: "1306011",
                                Deck: ["703601", "703602", "703603", "703604", /*"703605",*/ "703611", "703612",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "70007",
                Name: "The Puppeteer",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Jae-heon",
                                BookID: "1307011",
                                Deck: ["703701", "703702", "703703", "703704", "703709",],
                            },
                            {
                                Name: "Weighty Puppet",
                                BookID: "1307041",
                                Deck: ["703714", "703714", "703714", "703715", "703716",],
                            },
                            {
                                Name: "Puppet Angelica",
                                BookID: "1307051",
                                Deck: ["703717", "703717", "703718", "703718", "703715", "703719",],
                            },
                            {
                                Name: "Puppet",
                                BookID: "1307021",
                                Deck: ["703710", "703710", "703710", "703710", "703711", "703711", "703711", "703711",],
                            },
                            {
                                Name: "Nimble Puppet",
                                BookID: "1307031",
                                Deck: ["703710", "703710", "703711", "703711", "703712", "703713", "703713",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "70008",
                Name: "The Blood-red Night",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Elena",
                                BookID: "1308011",
                                Deck: ["703801", "703802", "703803", "703804", "703805",],
                            },
                            {
                                Name: "The Vermilion Cross",
                                BookID: "1308021",
                                Deck: ["703811", "703812", "703813", "703814", "703815",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "70009",
                Name: "Yesterday's Promise",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Pluto",
                                BookID: "1309011",
                                Deck: ["703901", "703902", "703903", "703904", "703905",],
                            },
                        ],
                    },
                ],
            },
            {
                ID: "610000",
                Name: "The Blue Reverberation",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Argalia",
                                BookID: "1310011",
                                Deck: ["703001", "703002", "703003", "703011", "703012", "703021",/* "703022",*/ "703031",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The Black Silence",
        Level: "Impuritas Civitatis",
        Episodes: [
            {
                ID: "60003",
                Name: "The Black Silence",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "The Black Silence",
                                BookID: "170001",
                                Deck: ["702001", "702002", "702003", "702004", "702005", "702006", "702007", "702008", "702009",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The Reverberation Ensemble Distorted",
        Level: "Impuritas Civitatis",
        Episodes: [
            {
                ID: "60004",
                Name: "The Reverb Ensemble Distorted",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "5",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Philip",
                                BookID: "1401011",
                                Deck: ["707101", "707101", "707102", "707102", "707103", "707103", "707103", "707104", "707104",],
                            },
                            {
                                Name: "Eileen",
                                BookID: "1402011",
                                Deck: ["707201", "707201", "707201", "707202", "707202", "707203", "707203", "707204", "707205",],
                            },
                            {
                                Name: "Greta",
                                BookID: "1403011",
                                Deck: ["707301", "707301", "707301", "707302", "707302", "707303", "707303", "707304", "707305",],
                            },
                            {
                                Name: "The Musicians of Bremen",
                                BookID: "1404011",
                                Deck: ["707401", "707401", "707402", "707402", "707403", "707403", "707404", "707404", "707405",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Oswald",
                                BookID: "1405011",
                                Deck: ["707501", "707502", "707503", "707504", "707505", "707506", "707507", "707508", "707509",],
                            },
                            {
                                Name: "Tanya",
                                BookID: "1406011",
                                Deck: ["707601", "707602", "707603", "707604", "707611", "707612", "707613",],
                            },
                            {
                                Name: "Jae-heon",
                                BookID: "1407011",
                                Deck: ["707701", "707702", "707703", "707704", "707705", "707706", "707707", "707708", "707709",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Argalia",
                                BookID: "1410011",
                                Deck: ["704011", "704014", "704001", "704012", "707001", "707002", "707003", "707011", "707012",],
                            },
                            {
                                Name: "Pluto",
                                BookID: "1409011",
                                Deck: ["707901", "707902", "707903", "707904", "707905", "707906",],
                            },
                            {
                                Name: "Elena",
                                BookID: "1408011",
                                Deck: ["707801", "707802", "707803", "707804", "707805",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "",
        Level: "Impuritas Civitatis",
        Episodes: [
            {
                ID: "60005",
                Name: "",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Philip",
                                BookID: "1401011",
                                Deck: ["707101", "707101", "707102", "707102", "707103", "707103", "707103", "707104", "707104",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "",
        Level: "Impuritas Civitatis",
        Episodes: [
            {
                ID: "60006",
                Name: "",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Argalia",
                                BookID: "1410011",
                                Deck: ["704011", "704014", "704001", "704012", "707001", "707002", "707003", "707011", "707012",],
                            },
                            {
                                Name: "Pluto",
                                BookID: "1409011",
                                Deck: ["707901", "707902", "707903", "707904", "707905", "707906",],
                            },
                            {
                                Name: "Elena",
                                BookID: "1408011",
                                Deck: ["707801", "707802", "707803", "707804", "707805",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "???",
        Level: "Impuritas Civitatis",
        Episodes: [
            {
                ID: "60007",
                Name: "???",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Zena",
                                BookID: "180001",
                                Deck: [],
                            },
                            {
                                Name: "Baral",
                                BookID: "180002",
                                Deck: [],
                            },
                        ],
                    },
                ],
            },
        ],
    },

    // General Invitation

    {
        Name: "Backstreets Butchers",
        Level: "Urban Myth",
        Episodes: [
            {
                ID: "100001",
                Name: "Backstreets Butchers",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Backstreets Butcher",
                                BookID: "111003",
                                Deck: ["201005", "201005", "201006", "201006", "201007", "201007", "200001", "200002",],
                            },
                            {
                                Name: "Backstreets Butcher",
                                BookID: "111004",
                                Deck: ["201005", "201005", "201006", "201007", "201007", "200004", "200005", "200002",],
                            },
                            {
                                Name: "Backstreets Butcher",
                                BookID: "111004",
                                Deck: ["201005", "201005", "201006", "201007", "201007", "200004", "200005", "200002",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Hook Office Remnants",
        Level: "Urban Myth",
        Episodes: [
            {
                ID: "100002",
                Name: "Hook Office Remnants",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Hook Fixer",
                                BookID: "111002",
                                Deck: ["104004", "104004", "104005", "104005", "104006", "104006", "200003", "200004",],
                            },
                            {
                                Name: "Hook Fixer",
                                BookID: "111002",
                                Deck: ["104004", "104004", "104005", "104005", "104006", "104006", "200003", "200004",],
                            },
                            {
                                Name: "Hook Fixer",
                                BookID: "111002",
                                Deck: ["104004", "104004", "104005", "104005", "104006", "104006", "200003", "200004",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Urban Myth-class Syndicate",
        Level: "Urban Myth",
        Episodes: [
            {
                ID: "100003",
                Name: "Urban Myth-class Syndicate",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Hook Fixer",
                                BookID: "111002",
                                Deck: ["104004", "104004", "104005", "104005", "104006", "104006", "200003", "200004",],
                            },
                            {
                                Name: "Backstreets Butcher",
                                BookID: "111003",
                                Deck: ["201005", "201005", "201006", "201006", "201007", "201007", "200001", "200002",],
                            },
                            {
                                Name: "Backstreets Butcher",
                                BookID: "111004",
                                Deck: ["201005", "201005", "201006", "201007", "201007", "200004", "200005", "200002",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Grade 8 Fixers",
        Level: "Urban Legend",
        Episodes: [
            {
                ID: "100004",
                Name: "Grade 8 Fixers",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Ordinary Grade 8 Fixer",
                                BookID: "121007",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Capable Grade 8 Fixer",
                                BookID: "121009",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Ordinary Grade 8 Fixer",
                                BookID: "121007",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Grade 7 Fixers",
        Level: "Urban Legend",
        Episodes: [
            {
                ID: "100005",
                Name: "Grade 7 Fixers",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Ordinary Grade 7 Fixer",
                                BookID: "121010",
                                Deck: ["303009", "303009", "303007", "300003", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Capable Grade 7 Fixer",
                                BookID: "121012",
                                Deck: ["303009", "303009", "303007", "300003", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Ordinary Grade 7 Fixer",
                                BookID: "121010",
                                Deck: ["303009", "303009", "303007", "300003", "300003", "300004", "303008", "303008",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Urban Legend-class Office",
        Level: "Urban Legend",
        Episodes: [
            {
                ID: "100006",
                Name: "Urban Legend-class Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Ordinary Grade 8 Fixer",
                                BookID: "121007",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Capable Grade 7 Fixer",
                                BookID: "121012",
                                Deck: ["303009", "303009", "303007", "300003", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Ordinary Grade 7 Fixer",
                                BookID: "121010",
                                Deck: ["303009", "303009", "303007", "300003", "300003", "300004", "303008", "303008",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Urban Legend-class Syndicate",
        Level: "Urban Legend",
        Episodes: [
            {
                ID: "100007",
                Name: "Urban Legend-class Syndicate",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Axe Gang Grunt",
                                BookID: "121013",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300003", "300004", "303008",],
                            },
                            {
                                Name: "Stray Dog",
                                BookID: "121005",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Stray Dog",
                                BookID: "121005",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Axe Gang Grunt",
                                BookID: "121013",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300003", "300004", "303008",],
                            },
                            {
                                Name: "Stray Dog",
                                BookID: "121005",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                            {
                                Name: "Stray Dog",
                                BookID: "121005",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300004", "303008", "303008",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Axe Gang",
        Level: "Urban Legend",
        Episodes: [
            {
                ID: "100008",
                Name: "Axe Gang",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "3",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Axe Gang Grunt",
                                BookID: "121013",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300003", "300004", "303008",],
                            },
                            {
                                Name: "Axe Gang Grunt",
                                BookID: "121013",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300003", "300004", "303008",],
                            },
                            {
                                Name: "Axe Gang Grunt",
                                BookID: "121013",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300003", "300004", "303008",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Axe Gang Executive",
                                BookID: "121014",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300003", "300004", "303008",],
                            },
                            {
                                Name: "Axe Gang Grunt",
                                BookID: "121013",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300003", "300004", "303008",],
                            },
                            {
                                Name: "Axe Gang Grunt",
                                BookID: "121013",
                                Deck: ["303009", "303009", "303007", "303007", "300003", "300003", "300004", "303008",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Rusted Chains",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "100009",
                Name: "Rusted Chains",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Rusted Chainlink",
                                BookID: "132002",
                                Deck: ["409001", "409001", "409001", "409002", "409002", "409003", "409004", "409004", "409005",],
                            },
                            {
                                Name: "Rusted Chainlink",
                                BookID: "132002",
                                Deck: ["409001", "409001", "409001", "409002", "409002", "409003", "409004", "409004", "409005",],
                            },
                            {
                                Name: "Rusted Chainlink",
                                BookID: "132002",
                                Deck: ["409001", "409001", "409001", "409002", "409002", "409003", "409004", "409004", "409005",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Jikan",
                                BookID: "132001",
                                Deck: ["409001", "409002", "409003", "409004", "409005", "409006", "409006", "409006", "409007",],
                            },
                            {
                                Name: "Rusted Chainlink",
                                BookID: "132002",
                                Deck: ["409001", "409001", "409001", "409002", "409002", "409003", "409004", "409004", "409005",],
                            },
                            {
                                Name: "Rusted Chainlink",
                                BookID: "132002",
                                Deck: ["409001", "409001", "409001", "409002", "409002", "409003", "409004", "409004", "409005",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Workshop-affiliated Fixers",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "100010",
                Name: "Workshop-affiliated Fixers",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Workshop-affiliated Fixer",
                                BookID: "133001",
                                Deck: ["410001", "410001", "408005", "408005", "410002", "410002", "410003", "410003", "410004",],
                            },
                            {
                                Name: "Workshop-affiliated Fixer",
                                BookID: "133001",
                                Deck: ["410001", "410001", "408005", "408005", "410002", "410002", "410003", "410003", "410004",],
                            },
                            {
                                Name: "Workshop-affiliated Fixer",
                                BookID: "133001",
                                Deck: ["410001", "410001", "408005", "408005", "410002", "410002", "410003", "410003", "410004",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Seven Association",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "100011",
                Name: "Seven Association",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "2",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Seven Association Fixer",
                                BookID: "143002",
                                Deck: ["511001", "511001", "511001", "511002", "511002", "511002", "511003", "511003", "511003",],
                            },
                            {
                                Name: "Seven Association Fixer",
                                BookID: "143002",
                                Deck: ["511001", "511001", "511001", "511002", "511002", "511002", "511003", "511003", "511003",],
                            },
                            {
                                Name: "Seven Association Fixer",
                                BookID: "143002",
                                Deck: ["511001", "511001", "511001", "511002", "511002", "511002", "511003", "511003", "511003",],
                            },
                            {
                                Name: "Seven Association Fixer",
                                BookID: "143002",
                                Deck: ["511001", "511001", "511001", "511002", "511002", "511002", "511003", "511003", "511003",],
                            },
                        ],
                    },
                    {
                        Enemies: [
                            {
                                Name: "Dante",
                                BookID: "143001",
                                Deck: ["511001", "511001", "511001", "511002", "511002", "511003", "511003", "511004", "511004",],
                            },
                            {
                                Name: "Seven Association Fixer",
                                BookID: "143002",
                                Deck: ["511001", "511001", "511001", "511002", "511002", "511002", "511003", "511003", "511003",],
                            },
                            {
                                Name: "Seven Association Fixer",
                                BookID: "143002",
                                Deck: ["511001", "511001", "511001", "511002", "511002", "511002", "511003", "511003", "511003",],
                            },
                            {
                                Name: "Seven Association Fixer",
                                BookID: "143002",
                                Deck: ["511001", "511001", "511001", "511002", "511002", "511002", "511003", "511003", "511003",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Blade Lineage",
        Level: "Urban Nightmare",
        Episodes: [
            {
                ID: "100012",
                Name: "Blade Lineage",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Bamboo Hat Kim",
                                BookID: "143003",
                                Deck: ["512001", "512001", "512002", "512006", "512003", "512003", "512004", "512005", "512005",],
                            },
                            {
                                Name: "Blade Lineage Cutthroat",
                                BookID: "143004",
                                Deck: ["512001", "512001", "512001", "512002", "512002", "512002", "512004", "512005", "512005",],
                            },
                            {
                                Name: "Blade Lineage Cutthroat",
                                BookID: "143004",
                                Deck: ["512001", "512001", "512001", "512002", "512002", "512002", "512004", "512005", "512005",],
                            },
                            {
                                Name: "Blade Lineage Cutthroat",
                                BookID: "143004",
                                Deck: ["512001", "512001", "512001", "512002", "512002", "512002", "512004", "512005", "512005",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Dong-hwan the Grade 1 Fixer",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "100013",
                Name: "Dong-hwan the Grade 1 Fixer",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Grade 1 Fixer Dong-hwan",
                                BookID: "143005",
                                Deck: ["512001", "512001", "513002", "513002", "513003", "513003", "513004", "513005", "513005",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Jeong's Office",
        Level: "Urban Plague",
        Episodes: [
            {
                ID: "100014",
                Name: "Jeong's Office",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Hanafuda",
                                BookID: "134001",
                                Deck: ["411101", "411101", "411102", "411102", "411103", "411103", "411104", "411104", "411105",],
                            },
                            {
                                Name: "Jeong's Office Fixer",
                                BookID: "134002",
                                Deck: ["411101", "411101", "411101", "411102", "411102", "411103", "411103", "411104", "411104",],
                            },
                            {
                                Name: "Jeong's Office Fixer",
                                BookID: "134002",
                                Deck: ["411101", "411101", "411101", "411102", "411102", "411103", "411103", "411104", "411104",],
                            },
                            {
                                Name: "Jeong's Office Fixer",
                                BookID: "134002",
                                Deck: ["411101", "411101", "411101", "411102", "411102", "411103", "411103", "411104", "411104",],
                            },
                            {
                                Name: "Jeong's Office Fixer",
                                BookID: "134002",
                                Deck: ["411101", "411101", "411101", "411102", "411102", "411103", "411103", "411104", "411104",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Night Awls",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "100015",
                Name: "Night Awls",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Allen",
                                BookID: "152001",
                                Deck: ["612001", "612001", "612002", "612002", "612003", "612003", "612004", "612005", "612006",],
                            },
                            {
                                Name: "Night Awl",
                                BookID: "152002",
                                Deck: ["612001", "612001", "612002", "612002", "612003", "612003", "612004", "612004", "612005",],
                            },
                            {
                                Name: "Night Awl",
                                BookID: "152002",
                                Deck: ["612001", "612001", "612002", "612002", "612003", "612003", "612004", "612004", "612005",],
                            },
                            {
                                Name: "Night Awl",
                                BookID: "152002",
                                Deck: ["612001", "612001", "612002", "612002", "612003", "612003", "612004", "612004", "612005",],
                            },
                            {
                                Name: "Night Awl",
                                BookID: "152002",
                                Deck: ["612001", "612001", "612002", "612002", "612003", "612003", "612004", "612004", "612005",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "The Udjat",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "100016",
                Name: "The Udjat",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Udjat",
                                BookID: "153001",
                                Deck: ["613001", "613001", "613002", "613002", "613003", "613003", "613004", "613005", "613006",],
                            },
                            {
                                Name: "Udjat",
                                BookID: "153001",
                                Deck: ["613001", "613001", "613002", "613002", "613003", "613003", "613004", "613005", "613006",],
                            },
                            {
                                Name: "Udjat",
                                BookID: "153001",
                                Deck: ["613001", "613001", "613002", "613002", "613003", "613003", "613004", "613005", "613006",],
                            },
                            {
                                Name: "Udjat",
                                BookID: "153001",
                                Deck: ["613001", "613001", "613002", "613002", "613003", "613003", "613004", "613005", "613006",],
                            },
                            {
                                Name: "Udjat",
                                BookID: "153001",
                                Deck: ["613001", "613001", "613002", "613002", "613003", "613003", "613004", "613005", "613006",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Mirae Life Insurance",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "100017",
                Name: "Mirae Life Insurance",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Irina",
                                BookID: "154001",
                                Deck: ["614001", "614001", "614002", "614002", "614003", "614003", "614003", "614004", "614005",],
                            },
                            {
                                Name: "Mirae Insurer",
                                BookID: "154002",
                                Deck: ["614001", "614001", "614002", "614002", "614003", "614003", "614003", "614004", "614005",],
                            },
                            {
                                Name: "Mirae Insurer",
                                BookID: "154002",
                                Deck: ["614001", "614001", "614002", "614002", "614003", "614003", "614003", "614004", "614005",],
                            },
                            {
                                Name: "Mirae Insurer",
                                BookID: "154002",
                                Deck: ["614001", "614001", "614002", "614002", "614003", "614003", "614003", "614004", "614005",],
                            },
                            {
                                Name: "Mirae Insurer",
                                BookID: "154002",
                                Deck: ["614001", "614001", "614002", "614002", "614003", "614003", "614003", "614004", "614005",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Leaflet Workshop",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "100018",
                Name: "Leaflet Workshop",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Yae",
                                BookID: "155001",
                                Deck: ["615001", "615001", "615002", "615002", "615003", "615003", "615004", "615005", "615006",],
                            },
                            {
                                Name: "Leaflet Workshop Fixer",
                                BookID: "155002",
                                Deck: ["615001", "615001", "615001", "615002", "615002", "615003", "615003", "615004", "615004",],
                            },
                            {
                                Name: "Leaflet Workshop Fixer",
                                BookID: "155002",
                                Deck: ["615001", "615001", "615001", "615002", "615002", "615003", "615003", "615004", "615004",],
                            },
                            {
                                Name: "Leaflet Workshop Fixer",
                                BookID: "155002",
                                Deck: ["615001", "615001", "615001", "615002", "615002", "615003", "615003", "615004", "615004",],
                            },
                            {
                                Name: "Leaflet Workshop Fixer",
                                BookID: "155002",
                                Deck: ["615001", "615001", "615001", "615002", "615002", "615003", "615003", "615004", "615004",],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        Name: "Bayard",
        Level: "Star of the City",
        Episodes: [
            {
                ID: "100019",
                Name: "Bayard",
                Need: [
                ],
                Condition: [
                ],
                FloorAvail: "1",
                Acts: [
                    {
                        Enemies: [
                            {
                                Name: "Bayard",
                                BookID: "156001",
                                Deck: ["616001", "616001", "616002", "616002", "616003", "616004", "616005",],
                            },
                            {
                                Name: "Bayard's Office Fixer",
                                BookID: "156002",
                                Deck: ["616001", "616001", "616001", "616002", "616002", "616003", "616003", "616004", "616004",],
                            },
                            {
                                Name: "Bayard's Office Fixer",
                                BookID: "156002",
                                Deck: ["616001", "616001", "616001", "616002", "616002", "616003", "616003", "616004", "616004",],
                            },
                            {
                                Name: "Bayard's Office Fixer",
                                BookID: "156002",
                                Deck: ["616001", "616001", "616001", "616002", "616002", "616003", "616003", "616004", "616004",],
                            },
                            {
                                Name: "Bayard's Office Fixer",
                                BookID: "156002",
                                Deck: ["616001", "616001", "616001", "616002", "616002", "616003", "616003", "616004", "616004",],
                            },
                        ],
                    },
                ],
            },
        ],
    },

]